import { RequestConfig } from '@/interface'

const PRIFIX = 'glht/'
const BLUR_PRIFIX = `${PRIFIX}fpkjLz/` // 蓝字发票
const RED_PRIFIX = 'fpgl/hzqrd/' // 红字确认单
const RECORD_PRIFIX = 'fpgl/kpjl/' // 开票记录
const INVOICE_PRIFIX = 'fpgl/fpkj/' // 发票开具
const DWONLOAD_PRIFIX = 'fpgl/fpxz/' // 发票下载记录

const invoicingConfig: RequestConfig = {
  // 蓝字待开列表
  lzdkList: {
    url: `${BLUR_PRIFIX}lzdkList`,
    method: 'post'
  },
  // 发给我的确认单列表
  fgwdqrdList: {
    url: `${RED_PRIFIX}fgwdqrdList`,
    method: 'post'
  },
  // 我发出的确认单列表
  wfcdqrdList: {
    url: `${RED_PRIFIX}wfcdqrdList`,
    method: 'post'
  },
  // 红字确认单详情
  hzqrdDetail: {
    url: `${RED_PRIFIX}detail`,
    method: 'post'
  },
  // 待开红字发票列表
  hzqrdQueryPageList: {
    url: `${RED_PRIFIX}queryPageList`,
    method: 'post'
  },
  // 红冲基本信息
  hcJbxx: {
    url: `${RED_PRIFIX}hcJbxx`,
    method: 'post'
  },
  // 红冲信息提交
  hcSubmit: {
    url: `${RED_PRIFIX}hcSubmit`,
    method: 'post'
  },
  // 红字确认单统计
  hzqrdTj: {
    url: `${RED_PRIFIX}hzqrdC`,
    method: 'post'
  },
  // 待对方确认列表
  ddfqrList: {
    url: `${RED_PRIFIX}ddfqrList`,
    method: 'post'
  },
  // 待我方确认列表
  dwfqrList: {
    url: `${RED_PRIFIX}dwfqrList`,
    method: 'post'
  },
  // 红字确认单确认Y N
  hzqrdqr: {
    url: `${RED_PRIFIX}hzqrdqr`,
    method: 'post'
  },
  // 开票信息提交
  kpSubmit: {
    url: `${RED_PRIFIX}kpSubmit`,
    method: 'post'
  },
  // 红字确认单导出
  hzqrdExport: {
    url: `${RED_PRIFIX}expert`,
    method: 'post'
  },
  // 蓝字发票对应红字确认单
  queryHzqrdByLzfp: {
    url: `${RED_PRIFIX}queryHzqrdByLzfp`,
    method: 'post'
  },
  // 红字确认单重新提交
  hcResubmit: {
    url: `${RED_PRIFIX}hcResubmit`,
    method: 'get'
  },
  // 更新红字确认单
  gxHzqrdList: {
    url: `${RED_PRIFIX}gxHzqrdList`,
    method: 'post'
  },
  // 清单导入红冲
  hzqrdFileImport: {
    url: `${RED_PRIFIX}hzqrdFileImport`,
    method: 'post'
  },
  // 清单导入红冲上传结果查询
  qddrhcUploadList: {
    url: `${RED_PRIFIX}uploadList`,
    method: 'post'
  },
  // 清单导入红冲上传状态查询
  qddrhcuploadResult: {
    url: `${RED_PRIFIX}uploadResult`,
    method: 'post'
  },
  // 根据参数匹配结果1(清单和参数导入红冲)
  fileParamQymcList1: {
    url: `${RED_PRIFIX}fileParamQymcList1`,
    method: 'post'
  },
  // 根据参数匹配结果2(清单和参数导入红冲)
  fileParamQymcList2: {
    url: `${RED_PRIFIX}fileParamQymcList2`,
    method: 'post'
  },
  // 提交(清单和参数导入红冲)
  fileParamQymcListSubmit: {
    url: `${RED_PRIFIX}fileParamQymcListSubmit`,
    method: 'post'
  },
  // 根据参数匹配(清单和参数导入红冲)
  fileParamQymcUpload: {
    url: `${RED_PRIFIX}fileParamQymcUpload`,
    method: 'post'
  },
  // 文件上传(清单和参数导入红冲)
  fileParamUpload: {
    url: `${RED_PRIFIX}fileParamUpload`,
    method: 'post'
  },
  // 上传结果查询(清单和参数导入红冲)
  fileParamUploadList: {
    url: `${RED_PRIFIX}fileParamUploadList`,
    method: 'post'
  },
  // 上传状态查询(清单和参数导入红冲)
  fileParamUploadResult: {
    url: `${RED_PRIFIX}fileParamUploadResult`,
    method: 'post'
  },
  // 单张寻蓝
  fileParamQymcSingleUpload: {
    url: `${RED_PRIFIX}fileParamQymcSingleUpload`,
    method: 'post'
  },
  // 寻蓝记录
  fileParamUploadLog: {
    url: `${RED_PRIFIX}fileParamUploadLog`,
    method: 'post'
  },
  // 发票详情信息
  fpMatchMx: {
    url: `${RED_PRIFIX}fpMatchMx`,
    method: 'post'
  },
  // 发票匹配信息
  fpMatchUploadMx: {
    url: `${RED_PRIFIX}fpMatchUploadMx`,
    method: 'post'
  },
  // 红字确认单更新记录列表
  updateLogList: {
    url: 'core/hzqrd/updateLog/list',
    method: 'post'
  },
  // 开票记录列表
  queryRecordPageList: {
    url: `${RECORD_PRIFIX}queryPageList`,
    method: 'post'
  },
  fpkjUpload: {
    url: `${RECORD_PRIFIX}upload`,
    method: 'post'
  },
  // 开票记录详情
  invoiceRecordDetail: {
    url: `${RECORD_PRIFIX}detail`,
    method: 'post'
  },
  // 红冲信息
  hzfpList: {
    url: `${RECORD_PRIFIX}hzfpList`,
    method: 'post'
  },
  // 重新提交
  cxtj: {
    url: `${RECORD_PRIFIX}cxtj`,
    method: 'post'
  },
  // 当前可开金额（纳税人）
  dqkkje: {
    url: `${INVOICE_PRIFIX}dqkkje`,
    method: 'post'
  },
  // 发票记录导出
  fpjlExport: {
    url: `${RECORD_PRIFIX}expert`,
    method: 'post'
  },
  // 发票删除
  invoiceDels: {
    url: `${RECORD_PRIFIX}dels`,
    method: 'post'
  },
  // 开票记录-税务模板-导出
  kpjlTaxExport: {
    url: `${RECORD_PRIFIX}expert/standard`,
    method: 'post'
  },
  // 发票文件上传
  invoiceUpload: {
    url: `${INVOICE_PRIFIX}upload`,
    method: 'post'
  },
  // 发票文件上传(不动产租赁)
  uploadBdczl: {
    url: `${INVOICE_PRIFIX}uploadBdczl`,
    method: 'post'
  },
  // 发票文件上传(建筑服务)
  uploadJzfw: {
    url: `${INVOICE_PRIFIX}uploadJzfw`,
    method: 'post'
  },
  // 发票文件上传(成品油)
  uploadCpy: {
    url: `${INVOICE_PRIFIX}uploadCpy`,
    method: 'post'
  },
  // 发票文件上传（机动车）
  uploadJdc: {
    url: `${INVOICE_PRIFIX}uploadJdc`,
    method: 'post'
  },
  // 上传结果查询
  invoiceUploadList: {
    url: `${INVOICE_PRIFIX}uploadList`,
    method: 'post'
  },
  // 上传状态查询
  invoiceUploadResult: {
    url: `${INVOICE_PRIFIX}uploadResult`,
    method: 'post'
  },
  // 批量开具
  batchSubmit: {
    url: `${INVOICE_PRIFIX}batchSubmit`,
    method: 'post'
  },
  // 批量导入记录
  queryPageListUpload: {
    url: `${INVOICE_PRIFIX}queryPageListUpload`,
    method: 'post'
  },
  // 提交开票
  tjkp: {
    url: `${INVOICE_PRIFIX}tjkp`,
    method: 'post'
  },
  // 提交单张开票
  tjDzkp: {
    url: `${INVOICE_PRIFIX}dzkp`,
    method: 'post'
  },
  // 单张开票-保存草稿
  dzkpBccp: {
    url: `${INVOICE_PRIFIX}dzkpBccp`,
    method: 'post'
  },
  // 单张开票-草稿项目
  dzkpBccgInfo: {
    url: `${INVOICE_PRIFIX}dzkpBccgInfo`,
    method: 'post'
  },
  // 配置税率
  kyslConf: {
    url: `${INVOICE_PRIFIX}kyslConf`,
    method: 'post'
  },
  // 删除草稿
  delDraft: {
    url: `${INVOICE_PRIFIX}dels`,
    method: 'post'
  },
  // 明细信息批量导入
  fpkjXmxxUpload: {
    url: `${INVOICE_PRIFIX}fpkjXmxxUpload`,
    method: 'post'
  },
  // 明细信息上传结果查询
  fpkjXmxxUploadList: {
    url: `${INVOICE_PRIFIX}fpkjXmxxUploadList`,
    method: 'post'
  },
  // 明细信息上传状态查询
  fpkjXmxxUploadResult: {
    url: `${INVOICE_PRIFIX}fpkjXmxxUploadResult`,
    method: 'post'
  },
  // 单张开票生成订单二维码
  dzkpOrderOrCode: {
    url: `${INVOICE_PRIFIX}orderQrCode`,
    method: 'post'
  },
  // 是否短信交付 ：1-是;0-否
  getSmsStatus: {
    url: `${INVOICE_PRIFIX}getSmsStatus`,
    method: 'get'
  },
  // 重新生成发票文件
  regenFpFile: {
    url: `${INVOICE_PRIFIX}regenFpFile`,
    method: 'get'
  },
  // 批量开具-导出详情
  dcPlkjXq: {
    url: `${RECORD_PRIFIX}expert`,
    method: 'post'
  },
  // 批量开具-编辑保存
  plkjEditor: {
    url: `${INVOICE_PRIFIX}editor`,
    method: 'post'
  },
  // 机动车合格证解锁
  jdcHgzJs: {
    url: `${INVOICE_PRIFIX}jdc/hgzJs`,
    method: 'post'
  },
  // 机动车人脸识别
  jdcRl: {
    url: `${INVOICE_PRIFIX}jdc/rl`,
    method: 'post'
  },
  // 机动车合格证信息查询
  jdcHgzcx: {
    url: `${INVOICE_PRIFIX}jdc/jdcHgzcx`,
    method: 'post'
  },
  // 获取机动车二维码
  jdcHgzEwq: {
    url: `${INVOICE_PRIFIX}jdc/jdcHgzEwq`,
    method: 'post'
  },
  // downLoad 发票
  downloadInvoice: {
    url: `${DWONLOAD_PRIFIX}download`, // /{uuid}
    method: 'get'
  },
  // 下载申请
  downloadLogReq: {
    url: `${DWONLOAD_PRIFIX}downloadLogReq`,
    method: 'post'
  },
  // 下载记录列表
  logsList: {
    url: `${DWONLOAD_PRIFIX}logsList`,
    method: 'post'
  },
  // 获取发票pdf地址
  getFpPdfUrl: {
    url: `${DWONLOAD_PRIFIX}getFpPdfUrl`, // /fphmfpdm
    method: 'get'
  },
  // 获取发票的流文件
  jbxxFjxxDownloadPdf: {
    url: `${DWONLOAD_PRIFIX}jbxxFjxxDownload`, // fphmfpdm
    method: 'get'
  },
  // 查看发票xml是否下载成功
  checkFpXml: {
    url: `${DWONLOAD_PRIFIX}checkFpXml`,
    method: 'get'
  },
  // 邮箱交付
  sendFpxxEmail: {
    url: `${DWONLOAD_PRIFIX}sendFpxxEmail`,
    method: 'post'
  },
  // 邮箱交付记录
  getFpjfLogs: {
    url: `${DWONLOAD_PRIFIX}getFpjfLogs`,
    method: 'post'
  },
  // 发票批量打印
  batchFpdy: {
    url: `${DWONLOAD_PRIFIX}fpdy`,
    method: 'post'
  },
  // 短信交付
  sendFpxxSms: {
    url: `${DWONLOAD_PRIFIX}sendFpxxSms`,
    method: 'post'
  },
  // 通过uuid获取发票信息
  getSmsFpmxByUuid: {
    url: `${DWONLOAD_PRIFIX}getSmsFpmxByUuid`,
    method: 'get'
  },
  // 出示二维码
  getFpEwmUrl: {
    url: `${DWONLOAD_PRIFIX}getFpEwmUrl`,
    method: 'get'
  },
  // 查询房源信息
  tdysCxfyxx: {
    url: 'tdys/fyxx/cxfyxx',
    method: 'post'
  },
  // 查询单笔跨区域涉税事项数据
  kqysssjdbcx: {
    url: 'tdys/jzfw/kqysssjdbcx',
    method: 'post'
  },
  // 批量查询跨区域涉税事项数据
  kqysssjplcx: {
    url: 'tdys/jzfw/kqysssjplcx',
    method: 'post'
  }
}
export default invoicingConfig
